import { useContext } from "react";
import { MdArrowOutward } from "react-icons/md";
import { AppContext } from "../App";
import { MotionReveal, MotionText } from "../components/MotionReveal";
import civilBackground from "../assets/civil engineering (1).jpg";
import excavatorImage from "../assets/excavator (1).png";

export default function HomeBanner() {
  const appContext = useContext(AppContext);

  function goToServices() {
    appContext.navTo({ item: "services" });
  }

  return (
    <section className="tgm-orion-hero" aria-label="SNJ Tanzania home banner">
      <div className="tgm-orion-hero-bg" aria-hidden="true">
        <img src={civilBackground} alt="" />
      </div>
      <div className="tgm-orion-hero-overlay" aria-hidden="true"></div>

      <div className="container tgm-orion-hero-shell">
        <div className="tgm-orion-copy">
          <h1
            className="tgm-orion-title"
            aria-label="If you can dream it, we can build it"
          >
            <MotionText
              as="span"
              className="tgm-orion-title-line"
              text="If you can dream it,"
              decorative
            />
            <MotionText
              as="span"
              className="tgm-orion-title-line"
              text="we can build it"
              delay={0.18}
              decorative
            />
          </h1>

          <MotionReveal
            as="button"
            type="button"
            className="tgm-orion-arrow-btn"
            onClick={goToServices}
            aria-label="Explore SNJ services"
            variant="image"
            delay={0.38}
            whileHover={{ y: -4, scale: 1.03 }}
            whileTap={{ scale: 0.95 }}
          >
            <MdArrowOutward />
          </MotionReveal>
        </div>

        <MotionReveal
          className="tgm-orion-machine-wrap"
          variant="right"
          delay={0.18}
          aria-hidden="true"
        >
          <img
            className="tgm-orion-machine"
            src={excavatorImage}
            alt=""
          />
        </MotionReveal>
      </div>
    </section>
  );
}
